import { render } from "./ServiceType.vue?vue&type=template&id=42b21d7c&scoped=true"
import script from "./ServiceType.vue?vue&type=script&lang=js"
export * from "./ServiceType.vue?vue&type=script&lang=js"

import "./ServiceType.vue?vue&type=style&index=0&id=42b21d7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b21d7c"]])

export default __exports__